import {
  Dialog as MUIDialog,
  DialogContent,
  Typography,
  styled,
} from "@mui/material";
import useStore from "../../Store/Store";
import { theme } from "../../Themes/Themes";
import "./Dialog.css";
import { useCallback } from "react";
import DialogButton from "./DialogButton";

const StyledDialog = styled(MUIDialog)({
  "& .MuiPaper-root": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    borderRadius: "30px",
    width: "50vw",
  },
});

const WelcomeTitle = styled(Typography)({
  textAlign: "center",
  margin: theme.spacing(3, 3, 0.8),
  fontSize: "25px",
  fontWeight: "Light",
  color: theme.custom.darkerGrey,
  paddingBottom: "20px",
});

export default function WelcomeDialog() {
  const { dialog, setDialog, currentRepo, loadSimulationByName } = useStore(
    (state) => ({
      dialog: state.dialog,
      setDialog: state.setDialog,
      currentRepo: state.currentRepo,
      loadSimulationByName: state.loadSimulationByName,
    })
  );

  const handleSkip = useCallback(() => {
    setDialog("");
  }, [setDialog]);

  const handleGuidedTutorial = useCallback(() => {
    loadSimulationByName("Codebase Overview");
    setDialog("");
  }, [loadSimulationByName, setDialog]);

  return (
    <StyledDialog open={dialog.type === "WELCOME_DIALOG"} onClose={handleSkip}>
      <DialogContent className="DialogContent">
        <br />
        <WelcomeTitle>Welcome to the {currentRepo} repo</WelcomeTitle>
        <div
          className="DialogButtonGroupHorizontal"
          style={{ paddingBottom: "10px" }}
        >
          <DialogButton
            onClick={handleSkip}
            text="Skip"
            data-testid="welcome-dialog-skip"
            style={{ marginRight: "30px" }}
          />
          <DialogButton
            onClick={handleGuidedTutorial}
            label="First time?"
            text="Repo Overview"
            style={{ marginLeft: "30px" }}
          />
        </div>
      </DialogContent>
    </StyledDialog>
  );
}
